var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "is-always-shadow box-card",
          attrs: { header: "兑换及提现" },
        },
        [
          _c(
            "el-row",
            { staticClass: "row-box" },
            [
              _c(
                "el-col",
                {
                  staticClass: "border",
                  attrs: { span: 12, xs: "24", sm: "12" },
                },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("p", [_vm._v("兑换")]),
                    ]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(140, 150, 168)",
                          padding: "20px 0px 0px",
                        },
                      },
                      [
                        _vm._v(
                          " 按照一定的汇率将INR(印度卢比)，兑换成USD(美元)或USDT(泰达币)或PAX"
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { margin: "30px 0" } }, [
                      _c("div", { staticClass: "mb20" }, [
                        _c("span", { staticClass: "number" }, [_vm._v("1")]),
                        _c("span", [_vm._v("账户内必须要有充足的INR可用余额")]),
                      ]),
                      _c("div", { staticClass: "mb20" }, [
                        _c("span", { staticClass: "number" }, [_vm._v("2")]),
                        _c("span", [_vm._v("如果兑换汇率有疑问，请联系商务")]),
                      ]),
                      _c("div", { staticClass: "mb20" }, [
                        _c("span", { staticClass: "number" }, [_vm._v("3")]),
                        _c("span", [
                          _vm._v("请于13:00:00-17:30:00内进行兑换操作"),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v("兑换"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "padding-left": "80px" },
                  attrs: { span: 12, xs: "24", sm: "12" },
                },
                [
                  _c("div", { staticClass: "grid-content" }, [
                    _c(
                      "div",
                      { staticClass: "title" },
                      [
                        _c("p", [_vm._v("提现")]),
                        _c(
                          "el-button",
                          {
                            staticClass: "addressButton",
                            attrs: { type: "warning" },
                          },
                          [_vm._v("提现地址管理")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(140, 150, 168)",
                          padding: "20px 0px 0px",
                        },
                      },
                      [
                        _vm._v(
                          " 将资金从商户账户提现至商户提供银行账户或加密数字货币地址 "
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { margin: "30px 0" } }, [
                      _c("div", { staticClass: "mb20" }, [
                        _c("span", { staticClass: "number right" }, [
                          _vm._v("1"),
                        ]),
                        _c("span", [
                          _vm._v(
                            "若账户内无可用USD/USDT/PAX可用余额，在提现前请先通过兑换功能兑换相应货币"
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "mb20" }, [
                        _c("span", { staticClass: "number right" }, [
                          _vm._v("2"),
                        ]),
                        _c("span", [
                          _vm._v(
                            "工作日提现到账时间：USDT/PAX当天到账；USD隔天到账(出现特殊情况可能会导致延迟)"
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    [
                      _c("el-button", { attrs: { type: "warning" } }, [
                        _vm._v("提现"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "is-always-shadow" },
        [
          _c(
            "el-tabs",
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "兑换" } },
                [
                  _c(
                    "el-form",
                    { attrs: { inline: true, "label-position": "top" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            { attrs: { placeholder: "状态" } },
                            [_c("el-option")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "兑换币种" } },
                        [
                          _c(
                            "el-select",
                            { attrs: { placeholder: "兑换币种" } },
                            [_c("el-option")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "开始时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "开始时间",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "结束时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "结束时间",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("搜索"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    [
                      _c("el-table-column", { attrs: { label: "创建时间" } }),
                      _c("el-table-column", { attrs: { label: "用户ID" } }),
                      _c("el-table-column", { attrs: { label: "应用 ID" } }),
                      _c("el-table-column", { attrs: { label: "应用名称" } }),
                      _c("el-table-column", { attrs: { label: "平台订单号" } }),
                      _c("el-table-column", { attrs: { label: "" } }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage4,
                      "page-sizes": [100, 200, 300, 400],
                      "page-size": 100,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: 400,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "提现" } },
                [
                  _c("p", { staticClass: "show-origin" }, [
                    _vm._v(" 查询原提现记录，请 "),
                    _c("span", [_vm._v("点击这里")]),
                  ]),
                  _c(
                    "el-form",
                    { attrs: { inline: true, "label-position": "top" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            { attrs: { placeholder: "状态" } },
                            [_c("el-option")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "提现币种" } },
                        [
                          _c(
                            "el-select",
                            { attrs: { placeholder: "提现币种" } },
                            [_c("el-option")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "开始时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "开始时间",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "结束时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "结束时间",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("el-button", { attrs: { type: "primary" } }, [
                            _vm._v("搜索"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    [
                      _c("el-table-column", { attrs: { label: "创建时间" } }),
                      _c("el-table-column", { attrs: { label: "用户ID" } }),
                      _c("el-table-column", { attrs: { label: "应用 ID" } }),
                      _c("el-table-column", { attrs: { label: "应用名称" } }),
                      _c("el-table-column", { attrs: { label: "平台订单号" } }),
                      _c("el-table-column", { attrs: { label: "" } }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage4,
                      "page-sizes": [100, 200, 300, 400],
                      "page-size": 100,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: 400,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }